<template>
  <el-checkbox id="rememberPwd" v-model="isChecked" @change="doRPWD">{{$t('cmsg.rememberPwd')}}</el-checkbox>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "remember-pwd",
  props: {
      formObj: {
          type: Object,
          default: {}
      }
  },
  data() {
    return {
        isChecked: false
    };
  },
  methods: {
      doRPWD(v) {
          console.log("remberPwd: ",v);
          console.log("form Obj: ",this.formObj);
          if(v){
              Cookies.set("remberPwd", v, {expires: 36500});
              Cookies.set("un", this.formObj.username, {expires: 36500});
              Cookies.set("upa", this.formObj.phoneArea, {expires: 36500});
            //   Cookies.set("ult", this.formObj.loginType, {expires: 36500});
              this.formObj.rPwd = true;
          }else {
              Cookies.remove("remberPwd");
              Cookies.remove("un");
              Cookies.remove("upa");
            //   Cookies.remove("ult");
              this.formObj.rPwd = false;
          }
      }
  },
  mounted(){
      if(Cookies.get("remberPwd")){
          this.isChecked=true;
      }
      this.$EventBus.$on("ndpwd",(v)=>{
          console.log("rrr: ", v);
          this.isChecked=v;
          this.doRPWD(v);
      })
  }
};
</script>
<style lang="scss">
#rememberPwd {
}
</style>
